import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ThemeToggle } from "./ui/theme-toggle";
import LanguageSwitcher from "./LanguageSwitcher";
import { useWallet } from "../contexts/WalletContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { ChevronDown, Wallet, Settings, Activity } from "lucide-react";

const Navbar: React.FC = () => {
  const { t } = useTranslation();
  const { walletAddress, isConnected, connectWallet, disconnectWallet } = useWallet();

  // Обработчик подключения/отключения кошелька
  const handleWalletAction = async () => {
    if (isConnected) {
      await disconnectWallet();
    } else {
      await connectWallet();
    }
  };

  // Сокращенный адрес кошелька для отображения
  const shortenedAddress = walletAddress 
    ? `${walletAddress.substring(0, 6)}...${walletAddress.substring(walletAddress.length - 4)}`
    : '';

  return (
    <header className="bg-background border-b">
      <div className="container flex h-16 items-center justify-between">
        <div className="flex items-center gap-6">
          <Link to="/" className="font-heading text-2xl font-bold">
            PEOPLEFFM
          </Link>
          <nav className="hidden md:flex gap-6">
            <Link to="/" className="text-sm font-medium transition-colors hover:text-primary">
              {t('header.home')}
            </Link>
            
            {/* Выпадающее меню для моделей */}
            <DropdownMenu>
              <DropdownMenuTrigger className="flex items-center text-sm font-medium transition-colors hover:text-primary">
                {t('header.models')}
                <ChevronDown className="ml-1 h-4 w-4" />
              </DropdownMenuTrigger>
              <DropdownMenuContent>
                <DropdownMenuItem asChild>
                  <Link to="/model-viewer" className="flex flex-col">
                    <span className="font-medium">Просмотр 3D моделей</span>
                    <span className="text-xs text-muted-foreground">Загрузка и просмотр моделей</span>
                  </Link>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
            
            <Link to="/" className="text-sm font-medium transition-colors hover:text-primary">
              {t('header.about')}
            </Link>
            
            {/* Ссылка на страницу администратора */}
            <Link to="/admin" className="flex items-center text-sm font-medium transition-colors hover:text-primary">
              <Settings className="mr-1 h-4 w-4" />
              Админ-панель
            </Link>
          </nav>
        </div>
        <div className="flex items-center gap-4">
          {/* Кнопка мониторинга производительности */}
          <Link 
            to="/admin" 
            title="Мониторинг производительности"
            className="flex items-center justify-center w-9 h-9 rounded-md border border-border hover:bg-accent transition-colors"
          >
            <Activity className="h-4 w-4" />
          </Link>
          
          {/* Кнопка кошелька */}
          <button
            onClick={handleWalletAction}
            className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium rounded-md border border-border hover:bg-accent transition-colors"
          >
            <Wallet className="h-4 w-4" />
            {isConnected ? (
              <span className="font-mono">{shortenedAddress}</span>
            ) : (
              <span>{t('wallet.connect')}</span>
            )}
          </button>
          
          <ThemeToggle />
          <LanguageSwitcher />
          <Link
            to="/model-viewer"
            className="inline-flex h-9 items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50"
          >
            {t('header.uploadModel')}
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Navbar; 